export default {
  init() {
    // JavaScript to be fired on all pages
    setTimeout(function(){
      $('#loading').fadeOut(function(){
        $(this).remove();
      });
    },400)

    console.log('ready player ONE!');
    
    $('.btn-filter').on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $('.filtros').toggleClass('oculto');
    });


    document.addEventListener( 'wpcf7mailsent', function( event ) {
      // Newsletter
      if ( '88331' == event.detail.contactFormId ) { // ID of the form 
        $('#modalNewsletter').modal('show');
      } else {
        $('#thisModal').modal('show');
      }
    }, false );

    $('.btn-share').on('click', function(e) {
      e.preventDefault();
      $('.mod-share_mobile').toggleClass('d-none', 'table-caption' );
    });


    // Obtener la URL de la página actual
    var currentPageUrl = window.location.href;
    $('.nav-item a').each(function() {
        // Obtener la URL del enlace de menú
        var menuLinkUrl = $(this).attr('href');
        
        // Comparar la URL de la página actual con la URL del enlace de menú
        if (currentPageUrl === menuLinkUrl) {
            // Agregar la clase "active" al elemento de menú actual
            $(this).closest('.nav-item').addClass('active');
        }
    });

    /**********+*********+*********+*********+*********+*********+*********+*********+
     * Buscador
     */
    $('.btn-cerrar').on('click', function(e) {
      e.preventDefault();
      clearForm();
      $('#form_buscador').addClass('d-none');
    });

    $('.js-buscador').on('click', function(e) {
      e.preventDefault();
      clearForm();
      $('#form_buscador').toggleClass('d-none');
    });

    // Predictivo
    var timerid;
    $("#paraula").on("input", function(e) {
      var value = $(this).val();
      if ( $(this).data("lastval") != value ) {

        $(this).data("lastval", value);
        clearTimeout(timerid);

        timerid = setTimeout(function() {
          ajaxBuscador();
          // console.log(value);
        }, 500);
      };
    });

    $('#buscador').change(function(e) {
      e.preventDefault();
      ajaxBuscador();
    });

    $("#buscador").submit(function(e) {
      e.preventDefault();
      ajaxBuscador();
    });

    function clearForm() {
      $('#form_buscador').find('form')[0].reset();
      $("#items-encontrados").html('');
    }

    function ajaxBuscador() {
      var paraula   = $('#paraula').val();
      var cat_array = [];
      $('#buscador input:checkbox:checked').each(function() {
        //if(values.indexOf($(this).val()) === -1){
          cat_array.push( $(this).val() );
        // }
      });
      console.log( paraula, cat_array );

      var ppp = 5; // Post per page
      var pageNumber = 1;

      var cat = JSON.stringify(cat_array);
      // console.log(cat);

      $.ajax({
          type: 'POST',
          url: window.global.ajax_url,
          data: { action: "buscarPost", "pageNumber": pageNumber, "ppp": ppp, "cat": cat, "paraula": paraula },
          dataType: 'HTML',
          success:function(response){
            console.log('success OK');

            if(response.length) {
                $("#items-encontrados").html(response);
                // $('html,body').animate({ scrollTop: $("#calendari_posts").offset().top}, 'slow');
            } else {
                console.log('0 resultados');
                $("#items-encontrados").html('<p class="text-center pt-5">No existen resultados</p>');
                // alert(responseText.message); // or whatever...
            }
          }, 
          error: function(errorThrown){
              alert('error');
              console.log(errorThrown);
          }
      });
    }




    /**********+*********+*********+*********+*********+*********+*********+*********+
     * Filtrar Categorias
     */
    $('#filtros').change(function() {
      var cat_array = [];

      $('#filtros input:checkbox:checked').each(function() {
        //if(values.indexOf($(this).val()) === -1){
          cat_array.push( $(this).val() );
        // }
      });
      // console.log( cat );

      buscarCategoria(cat_array);
    });

    function buscarCategoria(cat_array){
      var ppp = 5; // Post per page
      var pageNumber = 1;

      var cat = JSON.stringify(cat_array);
      // console.log(cat);
      $.ajax({
          type: 'POST',
          url: window.global.ajax_url,  // "<?php echo admin_url('admin-ajax.php'); ?>",
          data: { action: "buscarPostCategoria", "pageNumber": pageNumber, "ppp": ppp, "cat": cat},
          dataType: 'HTML',
          // contentType: "application/json; charset=utf-8",
          // async: false,
          // encode: true,
          success:function(response){
            console.log('success OK');

            if(response.length) {
                $("#items-listados").html(response);
                // $('#filtros').find("[data-cat='"+ cat +"']").addClass('active');
                // $('html,body').animate({ scrollTop: $("#calendari_posts").offset().top}, 'slow');
            } else {
                $("#items-listados").html('<h3 class="text-center">No existen resultados</h3>');
                // alert(responseText.message); // or whatever...
            }
          }, 
          error: function(errorThrown){
              alert('error');
              console.log(errorThrown);
          }
      });
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};


// function Share(element) {
// 	const canShare = 'share' in window.navigator;
// 	const options = element.dataset.share.split(' ');
// 	const shareIndex = options.findIndex(option => { return option === 'device' });
// 	const shareData = {
// 		facebook: { url: 'https://www.facebook.com/share.php?u=' },
// 		linkedin: { url: 'https://www.linkedin.com/shareArticle?mini=true&url' },
//     telegram: { url: 'https://t.me/share/url?url=' },
// 		twitter: { url: 'https://www.twitter.com/share?url=' }
// 	}

// 	if (shareIndex > -1 && !canShare) {
// 		options.splice(shareIndex, 1);
// 	}

// 	if (shareIndex > -1 && canShare) {
// 		const shareButton = h('button', {
// 			'aria-label': `${element.dataset.shareDevice}`,
// 			'data-share-item': ''
// 		}, [h('i')]);
// 		shareButton.addEventListener('click', () => {
// 			navigator.share({
// 				title: document.title,
// 				url: location.href
// 			}).catch(() => { return });
// 		})
// 		element.appendChild(shareButton);
// 	}
// 	else {
// 		options.forEach(option => {
// 			const shareLink = h('a', {
// 				'aria-label': `${element.dataset.shareLabel} ${option}`,
// 				'data-share-item': option,
// 				href: shareData[option].url + encodeURIComponent(location.href),
// 				rel: 'noopener noreferrer',
// 				target: '_blank'
// 			}, [h('i')])
// 			element.appendChild(shareLink);
// 		})
// 	}
// }

function h(type, attributes, children = []) {
	const element = document.createElement(type);
	for (let key in attributes) {
		element.setAttribute(key, attributes[key]);
	}
	if (children.length) {
		children.forEach(child => {
			if (typeof child === 'string') {
				element.appendChild(document.createTextNode(child));
			} else {
				element.appendChild(child);
			}
		});
	}
	return element;
}

/* Init Share */
// const shares = document.querySelectorAll(`[data-share]`);
// shares.forEach(element => {
// 	Share(element);
// });


window.addEventListener('scroll', function() {
  var header = document.querySelector('header');

  if (window.scrollY > 120) {
      header.classList.add('sticky');
      $('.mod-rastro-miga').fadeOut(600);
  } else {
      header.classList.remove('sticky');
      $('.mod-rastro-miga').fadeIn(600);
  }
});



// WEBPACK FOOTER //
// ./scripts/routes/common.js